
export default {
  name: 'SectionHowto',
  props: {
    item: {
      type: Object
    },
    translation: {
      type: Object,
      required: true,
      headline: {
        type: String,
        required: true
      },
      text: {
        type: String
      },
      step_1_headline: {
        type: String,
        required: true
      },
      step_2_headline: {
        type: String,
        required: true
      },
      step_3_headline: {
        type: String,
        required: true
      }
    }
  }
}
